import { useParams } from "react-router-dom";
import NotFound from "./NotFound";

import SIPCalculator from "./calculators/SIPCalculator";
import EMICalculator from "./calculators/EMICalculator";
import FDCalculator from "./calculators/FDCalculator";
import RDCalculator from "./calculators/RDCalculator";
import CompoundInterestCalculator from "./calculators/CompoundInterestCalculator";
import RetirementCalculator from "./calculators/RetirementCalculator";
import LoanEligibilityCalculator from "./calculators/LoanEligibilityCalculator";
import GSTCalculator from "./calculators/GSTCalculator";
import IncomeTaxCalculator from "./calculators/IncomeTaxCalculator";
import InflationCalculator from "./calculators/InflationCalculator";

const MAP = {
  sip: SIPCalculator,
  emi: EMICalculator,
  fd: FDCalculator,
  rd: RDCalculator,
  "compound-interest": CompoundInterestCalculator,
  retirement: RetirementCalculator,
  "loan-eligibility": LoanEligibilityCalculator,
  gst: GSTCalculator,
  "income-tax": IncomeTaxCalculator,
  inflation: InflationCalculator,
};

function CalculatorPage() {
  const { slug } = useParams();
  const Component = MAP[slug];
  if (!Component) return <NotFound />;
  return <Component />;
}

export default CalculatorPage;
